import { render } from "./addlocation.vue?vue&type=template&id=042fee4a"
import script from "./addlocation.vue?vue&type=script&lang=js"
export * from "./addlocation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__